import get from 'lodash/get';
import fetch from '../fetch';
import { fulfillmentErrorMessages } from './errors';
import fulfillFlexDownsell, {
  FLEX_DOWNSELL_FULFILLMENT_FAILED,
  MIGRATION_BLOCKED_ERROR_INFO,
} from './fulfillFlexDownsell';
import { channels, products } from '../../constants';
import isFlexUser from '../../helpers/isFlexUser';

export const FULFILL_SUBSCRIPTION = 'FULFILL_SUBSCRIPTION';
export const SUBSCRIPTION_FULFILLED = 'SUBSCRIPTION_FULFILLED';
export const FULFILLMENT_FAILED = 'FULFILLMENT_FAILED';
export const fulfillmentEndpoint = 'fulfillments';

const defaultChannel = channels.online;

const isValidOfferId = offerId =>
  (typeof offerId === 'string' && offerId.length > 0) || (typeof offerId === 'number' && Number.isFinite(offerId));

export default function fulfill(
  offerId,
  channel = defaultChannel,
  errorMessageKey = undefined,
  isCoolingOffSplitEnabled = false,
  options = {}
) {
  return async (dispatch, getState) => {
    const currentState = getState();
    const isFlexSplitEnabled = isFlexUser(currentState.split);
    const hasCurrentSubscriptionPlanCode = Boolean(currentState.subscriptions?.current?.planCode);
    const isFlexFlow = isFlexSplitEnabled || hasCurrentSubscriptionPlanCode;
    const isCancelJourney = options?.journey === 'cancel';
    const isFlexMigrationFailed = options?.isFlexMigrationFailed === true;

    // Set loading immediately so UI shows spinner before flex entitlements call and during polling.
    dispatch({ type: FULFILL_SUBSCRIPTION, meta: { clearErrors: true } });

    if (isFlexFlow && isCancelJourney) {
      const hasIsFlexCustomerFlag = options && Object.hasOwn(options, 'isFlexCustomer');
      const flexPlanCode = hasIsFlexCustomerFlag ? options?.planCode || offerId : offerId;
      const flexDownsellResult = await dispatch(fulfillFlexDownsell(flexPlanCode, channel, errorMessageKey));

      const isMigrationBlockedFailure =
        flexDownsellResult?.type === FLEX_DOWNSELL_FULFILLMENT_FAILED &&
        flexDownsellResult?.meta?.errorInfo === MIGRATION_BLOCKED_ERROR_INFO;

      if (!isMigrationBlockedFailure) {
        return flexDownsellResult;
      }
    }

    const errorMessage = JSON.stringify(fulfillmentErrorMessages[errorMessageKey] || fulfillmentErrorMessages.default);

    if (!isValidOfferId(offerId)) {
      return dispatch({
        type: FULFILLMENT_FAILED,
        error: true,
        payload: new Error(errorMessage),
      });
    }

    const isAmend =
      currentState.productDetails.isBreach &&
      [products.breach, products.breachPlus].includes(currentState.selection.family);
    const request = {
      method: `${isAmend ? 'PUT' : 'POST'}`,
      body: {
        channel,
        offerId,
        isCoolOffNewJourney: isCoolingOffSplitEnabled,
        isFlexMigrationFailed,
      },
    };
    const url = `/${fulfillmentEndpoint}${isAmend ? '/amend' : ''}`;

    let fulfillmentResultAction = {};

    try {
      const fulfilled = await dispatch(fetch(url, request));
      const succeeded = !!get(fulfilled, 'data[0].subscriptionId', false);

      fulfillmentResultAction = {
        type: SUBSCRIPTION_FULFILLED,
        payload: { success: succeeded },
      };
    } catch (error) {
      fulfillmentResultAction = {
        type: FULFILLMENT_FAILED,
        error: true,
        payload: new Error(errorMessage),
      };
    }

    return dispatch(fulfillmentResultAction);
  };
}
